import * as React from 'react'

export const SVG_Warning = ({
    className,
    color,
    height,
    width,
}: {
    className?: string
    color?: string
    height?: string
    width?: string
}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={width || 22}
        height={height || 20}
        viewBox="0 0 22 20"
    >
        <g fill={color ? color : 'currentColor'} fillRule="evenodd">
            <path d="M11.012 14c-.55 0-1.012.456-1.012 1s.461 1 1.012 1c.53 0 1.011-.456.987-.976A.982.982 0 0 0 11.012 14z" />
            <path
                fillRule="nonzero"
                d="M21.465 18.04a3.821 3.821 0 0 0 .009-3.887L14.392 1.956A3.851 3.851 0 0 0 11.004 0c-1.42 0-2.686.733-3.387 1.952L.526 14.162a3.852 3.852 0 0 0 .013 3.909A3.874 3.874 0 0 0 3.918 20h14.146a3.899 3.899 0 0 0 3.4-1.96zm-1.538-.882a2.14 2.14 0 0 1-1.868 1.075H3.913a2.11 2.11 0 0 1-1.845-1.053 2.118 2.118 0 0 1-.005-2.145L9.155 2.829a2.1 2.1 0 0 1 1.85-1.066c.773 0 1.465.4 1.849 1.07L19.94 15.04a2.09 2.09 0 0 1-.014 2.119z"
            />
            <path d="M10.764 6.031c-.47.15-.764.625-.764 1.201.024.348.044.7.067 1.047l.202 3.947c.024.448.337.774.74.774.405 0 .722-.348.741-.8 0-.273 0-.524.024-.801.044-.85.091-1.699.135-2.548.024-.55.067-1.1.091-1.65 0-.198-.024-.374-.091-.55-.202-.492-.673-.743-1.145-.62z" />
        </g>
    </svg>
)
